export default __webpack_public_path__ + "static/media/arrowLeft.07903bf0.svg";